let $bar = document.querySelector('.js-top-bar')
let $inner

if ($bar) init($bar)

function init ($bar) {
  $inner = $bar.firstElementChild
  let activeIndex = 0
  let $items = Array.from($bar.querySelectorAll('.js-top-bar-item'))
  let $prev = $bar.querySelector('.js-top-bar-prev')
  let $next = $bar.querySelector('.js-top-bar-next')
  let $close = $bar.querySelector('.js-top-bar-close')
  let $index = $bar.querySelector('.js-top-bar-index')

  $close.addEventListener('click', e => {
    e.stopPropagation()
    if (window.innerWidth < 1060 && document.body.classList.contains('top-bar-open')) {
      toggle()
    } else {
      $bar.parentNode.removeChild($bar)
      document.getElementById('nav').style.marginTop = 0
    }
  })

  if ($next && $prev) {
    $next.addEventListener('click', () => {
      $items[activeIndex].classList.remove('top-bar-active')
      activeIndex++
      $items[activeIndex].classList.add('top-bar-active')
      $index.textContent = activeIndex + 1
      if (activeIndex === $items.length - 1) {
        $next.disabled = true
      }
      $prev.disabled = false
    })

    $prev.addEventListener('click', () => {
      $items[activeIndex].classList.remove('top-bar-active')
      activeIndex--
      $items[activeIndex].classList.add('top-bar-active')
      $index.textContent = activeIndex + 1
      if (activeIndex === 0) {
        $prev.disabled = true
      }
      $next.disabled = false
    })
  }

  $bar.addEventListener('click', () => {
    if (
      window.innerWidth >= 1060 ||
      document.body.classList.contains('top-bar-open')
    ) {
      return
    }

    toggle()
  })

  document.querySelector('.js-top-bar-overlay').addEventListener('click', toggle)
}

let duration = 600
let frameTime = 1000 / 60
let nFrames = Math.round(duration / frameTime)
let $style = document.createElement('style')
document.head.appendChild($style)
let percentIncrement = 100 / nFrames

function clamp (value, min, max) {
  return Math.max(min, Math.min(max, value))
}

function ease (v, pow = 4) {
  v = clamp(v, 0, 1)

  return 1 - Math.pow(1 - v, pow)
}

function toggle () {
  let outerAnim = []
  let innerAnim = []

  $bar.style.animationName = ''
  $inner.style.animationName = ''

  let first = $bar.getBoundingClientRect()

  if (document.body.classList.contains('top-bar-open')) {
    document.querySelector('.ex-site').style.marginTop = 0
    document.body.classList.remove('top-bar-open')
  } else {
    document.querySelector('.ex-site').style.marginTop = `${$bar.offsetHeight}px`
    document.body.classList.add('top-bar-open')
  }

  let last = $bar.getBoundingClientRect()
  let x = first.width / last.width
  let y = first.height / last.height

  for (let i = 0; i <= nFrames; i++) {
    let step = ease(i / nFrames).toFixed(5)
    let percentage = (i * percentIncrement).toFixed(5)
    let startX = x
    let endX = 1
    let startY = y
    let endY = 1

    let xScale = (startX + (endX - startX) * step).toFixed(5)
    let invScaleX = (1 / xScale).toFixed(5)
    let yScale = (startY + (endY - startY) * step).toFixed(5)
    let invScaleY = (1 / yScale).toFixed(5)

    outerAnim.push(`
      ${percentage}% {
        transform: scale(${xScale}, ${yScale});
      }
    `)

    innerAnim.push(`
      ${percentage}% {
        transform: scale(${invScaleX}, ${invScaleY});
      }
    `)
  }

  $style.textContent = `
    @keyframes topbarAnimation {
      ${outerAnim.join('')}
    }

    @keyframes topbarContentsAnimation {
      ${innerAnim.join('')}
    }
  `

  $bar.style.animationName = 'topbarAnimation'
  $inner.style.animationName = 'topbarContentsAnimation'
}



// WEBPACK FOOTER //
// ./src/js/_top-bar.js